import { Injectable } from "@angular/core";
import { QueueSocketsService } from "../services/queuesockets.service";
import { Observable } from "rxjs";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";

@Injectable()
export class QueueSocketResolver implements Resolve<any> {
  constructor(private queueSocketsService: QueueSocketsService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const refcode = route.paramMap.get("refcode");
    if (refcode) {
      this.queueSocketsService.initializeChannels(refcode);
    }
    return this.queueSocketsService.connect();
  }
}
